/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Popover, PopoverProps } from 'react-tiny-popover';
import { isCursorInElement } from '../../helpers/functions';

interface TooltipProps extends Omit<PopoverProps, 'isOpen'> {
  trigger?: 'click' | 'hover';
}
// eslint-disable-next-line import/prefer-default-export
export const Tooltip: React.FC<TooltipProps> = (props) => {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  const { children, content, positions = ['top'], trigger, ...rest } = props;
  return (
    <Popover
      transformMode="absolute"
      isOpen={open}
      reposition={false}
      onClickOutside={() => setOpen(false)}
      positions={['top', 'right']}
      content={
        <div
          ref={ref}
          onMouseLeave={() => trigger !== 'click' && setOpen(false)}
        >
          {content}
        </div>
      }
      {...rest}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        onClick={() => trigger === 'click' && setOpen(!open)}
        onMouseEnter={() => trigger !== 'click' && setOpen(true)}
        onMouseLeave={(e) => {
          if (trigger !== 'click' && !isCursorInElement(e, ref?.current)) {
            setOpen(false);
          }
        }}
      >
        {children}
      </div>
    </Popover>
  );
};
